document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.form-successfully__custom-modal-close').forEach(button => {
    button.addEventListener('click', function () {
      document.querySelectorAll('.form-successfully__custom-modal').forEach(cm => {
        cm.style.display = 'none';
        cm.style.pointerEvents = 'none';
      });
    });
  });
});